let actions = {
	EMBARALHAR: 'EMBARALHAR',
	LIMITAR: 'LIMITAR',
	DISTRIBUIR: 'DISTRIBUIR',
	QTDJOGADORES: 'QTDJOGADORES',
	PROXJOGADOR: 'PROXJOGADOR',
	PREPARAJOGO: 'PREPARAJOGO',
	STATUSCARTAS: 'STATUSCARTAS',
	QTDCARTAS: 'QTDCARTAS',
	NOMEJOGADOR: 'NOMEJOGADOR',
	CARTAX: 'CARTAX',
	INICIAHISTORIA: 'INICIAHISTORIA',
	SEQUENCIANUMERO: 'SEQUENCIANUMERO',
	SEQUENCIACARTA: 'SEQUENCIACARTA',
	SEQUENCIAHISTORIA: 'SEQUENCIAHISTORIA',
	MUDAINGLES: 'MUDAINGLES',
	MUDAPORTUGUES: 'MUDAPORTUGUES',
}
export default actions;



// WEBPACK FOOTER //
// ./src/constants/app-constants.js